export const SUGGESTIONS_BOARD_URL = 'https://suggestions.colonist.io';
